/**
 * Utilitaire pour générer le template Excel d'import de sorties.
 * Ce fichier est NOUVEAU et n'affecte pas les utilitaires existants.
 *
 * Utilise exceljs pour générer un vrai fichier Excel (.xlsx)
 */
import ExcelJS from "exceljs";

/**
 * Génère et télécharge le template Excel pour l'import de sorties
 */
export const generateSortiesTemplate = async () => {
  try {
    // Créer un nouveau workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sorties");

    // Définir les colonnes
    worksheet.columns = [
      { header: "Date", key: "date", width: 15 },
      { header: "Intitulé", key: "intitule", width: 25 },
      { header: "Fournisseur", key: "fournisseur", width: 25 },
      { header: "Compte Fournisseur", key: "compte_fournisseur", width: 18 },
      { header: "Source paiement", key: "source_paiement", width: 20 },
      { header: "Taxes", key: "taxes", width: 10 },
      { header: "Remise", key: "remise", width: 10 },
      { header: "Montant payé", key: "montant_paye", width: 15 },
      { header: "Nom produit", key: "nom_produit", width: 25 },
      { header: "Description", key: "description", width: 30 },
      { header: "Compte de Charge", key: "compte_charge", width: 18 },
      { header: "Quantité", key: "quantite", width: 12 },
      { header: "Prix unitaire", key: "prix_unitaire", width: 15 },
    ];

    // Styliser l'en-tête
    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF009688" },
    };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.height = 25;

    // Ajouter des lignes d'exemple
    const exampleRows = [
      {
        date: "15/01/2026",
        intitule: "Achat janvier",
        fournisseur: "Fournisseur Test A",
        compte_fournisseur: "40110025",
        source_paiement: "banque",
        taxes: 18,
        remise: 0,
        montant_paye: 50000,
        nom_produit: "Ordinateur Portable",
        description: "Dell Latitude 5420",
        compte_charge: "605100",
        quantite: 1,
        prix_unitaire: 500000,
      },
      {
        date: "15/01/2026",
        intitule: "Achat janvier",
        fournisseur: "Fournisseur Test A",
        compte_fournisseur: "40110025",
        source_paiement: "banque",
        taxes: 18,
        remise: 0,
        montant_paye: 50000,
        nom_produit: "Souris Sans Fil",
        description: "Logitech MX Master",
        compte_charge: "601100",
        quantite: 2,
        prix_unitaire: 25000,
      },
      {
        date: "16/01/2026",
        intitule: "Achat février",
        fournisseur: "Fournisseur Test B",
        compte_fournisseur: "",
        source_paiement: "caisse",
        taxes: 18,
        remise: 5,
        montant_paye: 100000,
        nom_produit: "Clavier Mécanique",
        description: "RGB Gaming",
        compte_charge: "",
        quantite: 1,
        prix_unitaire: 75000,
      },
    ];

    // Ajouter les lignes d'exemple
    exampleRows.forEach((row) => {
      worksheet.addRow(row);
    });

    // Styliser les lignes d'exemple (alternance de couleurs)
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin", color: { argb: "FFD3D3D3" } },
            left: { style: "thin", color: { argb: "FFD3D3D3" } },
            bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
            right: { style: "thin", color: { argb: "FFD3D3D3" } },
          };
          cell.alignment = { vertical: "middle" };
        });

        // Alternance de couleurs
        if (rowNumber % 2 === 0) {
          row.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F5F5" },
          };
        }
      }
    });

    // Ajouter une feuille d'instructions
    const instructionsSheet = workbook.addWorksheet("Instructions");
    instructionsSheet.columns = [{ width: 80 }];

    const instructions = [
      {
        text: "INSTRUCTIONS POUR L'IMPORT DE SORTIES",
        bold: true,
        size: 16,
        color: "009688",
      },
      { text: "" },
      { text: "FORMAT DU FICHIER :", bold: true, size: 12 },
      { text: "• Le fichier doit contenir 13 colonnes dans l'ordre indiqué" },
      {
        text: "• La première ligne doit contenir les en-têtes (ne pas modifier)",
      },
      { text: "• Les lignes suivantes contiennent les données" },
      { text: "" },
      { text: "COLONNES REQUISES :", bold: true, size: 12 },
      { text: "1. Date (format: JJ/MM/AAAA) - OBLIGATOIRE" },
      { text: "2. Intitulé - OBLIGATOIRE" },
      { text: "3. Fournisseur - OBLIGATOIRE" },
      { text: "4. Compte Fournisseur - Optionnel (ex: 40110025, classe 4, si vide auto-généré)" },
      {
        text: "5. Source paiement (banque, caisse, wave, orange_money) - Optionnel",
      },
      { text: "6. Taxes (pourcentage, ex: 18) - Optionnel" },
      { text: "7. Remise (pourcentage, ex: 5) - Optionnel" },
      { text: "8. Montant payé - Optionnel" },
      { text: "9. Nom produit - OBLIGATOIRE" },
      { text: "10. Description - Optionnel" },
      { text: "11. Compte de Charge - Optionnel (ex: 601, 605, classe 6, si vide IA génère)" },
      { text: "12. Quantité - OBLIGATOIRE (doit être > 0)" },
      { text: "13. Prix unitaire - OBLIGATOIRE (doit être > 0)" },
      { text: "" },
      { text: "RÈGLES DE GROUPEMENT :", bold: true, size: 12 },
      {
        text: "Les lignes avec la même Date, le même Intitulé et le même Fournisseur",
      },
      {
        text: "seront regroupées en UNE SEULE sortie avec plusieurs produits.",
      },
      { text: "" },
      { text: "EXEMPLE :", bold: true, size: 12 },
      { text: "Si vous avez 3 lignes avec :" },
      { text: "  • Date: 15/01/2026" },
      { text: "  • Intitulé: Achat janvier" },
      { text: "  • Fournisseur: Fournisseur A" },
      { text: "→ Résultat : 1 sortie avec 3 produits" },
      { text: "" },
      { text: "CODES COMPTABLES :", bold: true, size: 12 },
      { text: "COMPTE FOURNISSEUR (colonne 4) :" },
      { text: "  • Optionnel : peut être laissé vide" },
      { text: "  • Format : numérique, 3 à 12 chiffres" },
      { text: "  • Classe : doit commencer par 4 (tiers SYSCOHADA)" },
      { text: "  • Exemples valides : 40110001, 40115001, 4011" },
      { text: "  • Si vide : auto-généré (40110001, 40110002, etc.)" },
      { text: "" },
      { text: "COMPTE DE CHARGE (colonne 11) :" },
      { text: "  • Optionnel : peut être laissé vide" },
      { text: "  • Format : numérique, 3 à 12 chiffres" },
      { text: "  • Classe : doit commencer par 6 (charges SYSCOHADA)" },
      { text: "  • Codes courts (3 chiffres) : 601 (marchandises), 605 (matériaux), 604 (fournitures)" },
      { text: "  • Codes complets (6 chiffres) : 601100 (marchandises), 605100 (matériaux), 604100 (fournitures)" },
      { text: "  • Si vide : IA génère automatiquement basé sur SYSCOHADA" },
      { text: "" },
      { text: "FOURNISSEURS :", bold: true, size: 12 },
      { text: "Si un fournisseur n'existe pas, il sera créé automatiquement." },
      { text: "  • Code comptable : selon colonne 4 ou auto-généré" },
      { text: "" },
      { text: "TAILLE MAXIMALE :", bold: true, size: 12 },
      { text: "10 MB par fichier" },
      { text: "" },
      { text: "FORMATS ACCEPTÉS :", bold: true, size: 12 },
      { text: ".xlsx, .xls" },
    ];

    instructions.forEach((instruction, index) => {
      const row = instructionsSheet.getRow(index + 1);
      row.getCell(1).value = instruction.text;

      if (instruction.bold) {
        row.getCell(1).font = {
          bold: true,
          size: instruction.size || 11,
          color: instruction.color
            ? { argb: `FF${instruction.color}` }
            : undefined,
        };
      }

      row.getCell(1).alignment = {
        vertical: "top",
        wrapText: true,
      };
      row.height = 20;
    });

    // Générer le fichier
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Télécharger le fichier
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "modele_import_sorties.xlsx");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Erreur lors de la génération du template:", error);
    throw error;
  }
};

export default {
  generateSortiesTemplate,
};
